import { Plugin } from '@nuxt/types';
import { AdFormOptions } from '@ads/types/AdForm';
import adsConfig from '@ads/config/adForm.config';

import getAdBlockLayerState from '@root/modules/ads/utils/getAdBlockLayerState';
import { detectAnyAdblocker } from 'vue-adblock-detector';

const portalAds: Plugin = async ctx => {
  const { store, app } = ctx;
  // Access channel settings
  const { application } = app.$channelConfig('settings');
  // Access default banner placements
  const placements: Record<string, AdFormOptions> | null = { ...app.$channelConfig('ads').component.adForm.placements };

  // Access paywall settings
  const { hasChannelAccess, adFree } = app.$instanceConnector('paywall').state;

  // disabled ads config
  const { adForm } = app.$channelConfig('ads').component;
  const disableAds = adForm.disableAds || adsConfig.disableAds;

  const defaultAdsSettings = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
    return {
      mkw: ['channel_vue', `logged-${isLoggedIn ? 'in' : 'out'}`],
      mkv: [],
      placements,
      disableAds,
    };
  };

  // Detect adblock and commit state independantly of customer/paywall state
  const adBlockEnabled = await detectAnyAdblocker();
  const enableAdBlockLayer = getAdBlockLayerState({ application, adBlockEnabled, hasChannelAccess, adFree });
  store.commit('adForm/setAdBlockLayerState', enableAdBlockLayer);

  const { isInited, isLoggedIn } = ctx.app.$instanceConnector('customer').state;

  if (isInited && !isLoggedIn) {
    store.commit('adForm/setAdsRenderingState', true);
    store.commit('adForm/setDefaultAdsSettings', defaultAdsSettings({ isLoggedIn }));
  } else {
    store.commit('adForm/setAdsRenderingState', false);
  }

  // Update ads settings when customer logs in and has access to channel or has adFree package
  app.$eventHandler.on('paywall-state', () => {
    // Access paywall settings
    const { hasChannelAccess, adFree } = app.$instanceConnector('paywall').state;

    store.commit('adForm/setAdsRenderingState', true);
    store.commit('adForm/setDisabledAdsCondition', { type: 'subscriber', disable: hasChannelAccess });
    store.commit('adForm/setDisabledAdsCondition', { type: 'adFree', disable: adFree });

    const isLoggedIn = ctx.app.$instanceConnector('customer').state.isLoggedIn;
    store.commit('adForm/setDefaultAdsSettings', defaultAdsSettings({ isLoggedIn }));
  });
};

export default portalAds;
